<template>
    <div class="window template-window" v-show="isVisible" ref="baseWindow">
        <img src="../image/ajax-loader.gif" v-show="isWaitingApiRequests"
             style="margin: 0; position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%); z-index: 10">
        <alert-window ref="alertWindow"></alert-window>
        <span class="close" title="Закрыть" @click="$emit('close-window', false)" v-show="!isWaitingApiRequests">
            <img src="../image/cancel.svg">
        </span>
        <div class="window-title">Применить шаблон</div>
        <div class="form">
            <div class="form-block">
                <div class="fieldset">
                    <label class="fieldset-title">Применить с</label>
                    <fieldset>
                        <date-picker
                                format="dd.MM.yyyy"
                                :language="datepickerLanguageRu"
                                :monday-first="true"
                                v-model="dateFrom"
                                :disabled="isWaitingApiRequests"
                        ></date-picker>
                    </fieldset>
                </div>
                <div class="fieldset">
                    <label class="fieldset-title">по</label>
                    <fieldset>
                        <date-picker
                                format="dd.MM.yyyy"
                                :language="datepickerLanguageRu"
                                :monday-first="true"
                                :highlighted="highlightedDates"
                                v-model="dateTo"
                                :disabled="isWaitingApiRequests"
                        ></date-picker>
                    </fieldset>
                </div>
                <div class="fieldset">
                    <label class="fieldset-title">Шаблон</label>
                    <div class="template-options visibility">
                        <div class="item" ref="52" @click="select('52')">
                            5/2
                        </div>
                        <div class="item" ref="22" @click="select('22')">
                            2/2
                        </div>
                        <div class="item" ref="13" @click="select('13')">
                            1/3
                        </div>
                        <div class="item" ref="25" @click="select('25')">
                            2/5
                        </div>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <button type="button" class="save-button" ref="saveButton" @click="save">Применить</button>
            </div>
        </div>
    </div>
</template>

<script>
  import api from '@/api'
  import DatePicker from '@codeanker/vuejs-datepicker'
  import {ru} from '@codeanker/vuejs-datepicker/dist/locale'
  import moment from 'moment'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
    name: 'ScheduleTemplate',
    props: ['isVisible', 'workersIdList'],
    components: {DatePicker, AlertWindow},

    data() {
      return {
        datepickerLanguageRu: ru,
        dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        dateTo: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
        selectedShift: null,
        workersWorkingHoursList: [],
        workers: [],
        isWaitingApiRequests: false
      }
    },
    watch: {
      isVisible(val) {
        if (val) {
          this.workers = this.workersIdList
          this.workersWorkingHoursList = []
          // предварительно загружаются рабочие смены
          this.workers.forEach((id) => {
            api.getWorker(id).then((worker) => {
              let list = []
              worker.first.workerWorkingTimes.forEach((x) => {
                list.push(worker.second.workingTimes[x - 1])
              })
              this.workersWorkingHoursList.push({
                id: id,
                workingHours: list
              })
            })
          })
        }
      }
    },
    methods: {
      // выбор графика по щелчку на кнопку
      select(shiftType) {
        if (!this.isWaitingApiRequests) {
          let shiftTypes = ['52', '22', '13', '25']
          shiftTypes.forEach((x) => {
            this.$refs[x].classList.remove('checked')
          })
          this.$refs[shiftType].classList.add('checked')
          this.selectedShift = shiftType
        }
      },
      save() {
        let days = []
        let currentDate = new Date(this.dateFrom);
        let stopDate = new Date(this.dateTo);
        while (currentDate.getTime() <= stopDate.getTime()) {
          days.push(new Date(currentDate))
          currentDate.setDate(currentDate.getDate() + 1);
        }

        if (this.workersWorkingHoursList.every((x) => (x.workingHours.length === 1))) {
          if (days.length > 1) {
            if (this.selectedShift) {
              for (let i = 0; i < this.workersWorkingHoursList.length; i++) {
                let shifts = this.getShiftsList(days, this.selectedShift)
                if (shifts) {
                  let workerSchedule = shifts.slice(0)
                  let additionalPeriodsForNightShifts = []
                  for (let j = 0; j < days.length; j++) {
                    let newSchedule = Object.assign({}, workerSchedule[j])
                    newSchedule.wkr_worker_id = this.workersWorkingHoursList[i].id
                    newSchedule.wsc_date = this.getDateString(days[j])
                    newSchedule.wsc_start_work_time = this.workersWorkingHoursList[i].workingHours[0].fromHour < 10 ? '0' + this.workersWorkingHoursList[i].workingHours[0].fromHour + ':00'
                      : this.workersWorkingHoursList[i].workingHours[0].fromHour + ':00'
                    newSchedule.wsc_end_work_time = this.workersWorkingHoursList[i].workingHours[0].toHour + ':00'

                    // если ночная смена, то остаток смены 00 - 08 кидаем в additionalPeriodsForNightShifts
                    if (this.workersWorkingHoursList[i].workingHours[0].fromHour === 21 && this.workersWorkingHoursList[i].workingHours[0].toHour === 8) {
                      newSchedule.wsc_end_work_time = '23:59'
                      if (!newSchedule.wsc_weekend) {
                        let per = Object.assign({}, workerSchedule[j])
                        per.wkr_worker_id = this.workersWorkingHoursList[i].id
                        per.wsc_start_work_time = '00:00'
                        per.wsc_end_work_time = '08:00'
                        per.wsc_date = this.getDateString(new Date(days[j]).setDate(days[j].getDate() + 1))

                        additionalPeriodsForNightShifts.push(per)
                      }
                    }
                    workerSchedule[j] = Object.assign({}, newSchedule)
                  }
                  // если есть ночные смены, то добавляем их в список к сохранению
                  if (additionalPeriodsForNightShifts.length > 0) {
                    workerSchedule.push.apply(workerSchedule, additionalPeriodsForNightShifts)
                  }

                  this.isWaitingApiRequests = true
                  this.$refs.saveButton.disabled = true

                  // предварительно очищаем распиание на период применения шаблона после чего сохраняем шаблон
                  api.deleteWorkerSchedule(this.workersWorkingHoursList[i].id, this.dateFrom.getTime(), this.dateTo.getTime(), false)
                    .then(() => {
                      api.setWorkerSchedule(workerSchedule)
                        .then(() => {
                          this.$refs.saveButton.disabled = false
                          this.$emit('close-window', false)
                          this.isWaitingApiRequests = false
                        })
                    })
                }
              }
            } else {
              this.$refs.alertWindow.show('Ошибка', 'Выберите график работы', false)
            }
          } else {
            this.$refs.alertWindow.show('Ошибка', 'Укажите верный временной промежуток', false)
          }
        } else {
          this.$refs.alertWindow.show('Ошибка', 'Выберите рабочих только с одной рабочей сменой', false)
        }
      },
      getShiftsList(days, shiftsType) {
        // класс для одного элемента(дня) расписания
        class Period {
          constructor(type) {
            this.wsc_id = 0
            this.wkr_worker_id = null
            this.wsc_date = null
            this.wsc_start_work_time = null
            this.wsc_end_work_time = null
            this.wsc_holiday = false
            if (!type || type === 'work') {
              this.wsc_weekend = false
            } else if (type === 'weekend') {
              this.wsc_weekend = true
            }
            this.wsc_worker_hill = false
          }
        }

        // минимальные периоды графиков - 2 по 4 и 2 по 7 дней для соответствующих типа графика
        let min22 = [new Period(), new Period(), new Period('weekend'), new Period('weekend')]
        let min13 = [new Period(), new Period('weekend'), new Period('weekend'), new Period('weekend')]
        let min52 = [new Period(), new Period(), new Period(), new Period(), new Period(), new Period('weekend'), new Period('weekend')]
        let min25 = [new Period(), new Period(), new Period('weekend'), new Period('weekend'), new Period('weekend'), new Period('weekend'), new Period('weekend')]
        let numberOfShifts = -1
        let m;
        let result = []
        switch (shiftsType) {
          case '22':
            numberOfShifts = Math.ceil(days.length / 4)
            m = min22.slice(0)
            break
          case '13':
            numberOfShifts = Math.ceil(days.length / 4)
            m = min13.slice(0)
            break
          case '52':
            numberOfShifts = Math.ceil(days.length / 7)
            m = min52.slice(0)
            break
          case '25':
            numberOfShifts = Math.ceil(days.length / 7)
            m = min25.slice(0)
            break
        }
        if (numberOfShifts > -1) {
          for (let i = 0; i < numberOfShifts; i++) {
            result.push.apply(result, m.slice(0))
          }
          return result.slice(0, days.length)
        } else {
          alert('Укажите подходящий временной промежуток')
        }
      },
      getDateString(d) {
        let date = new Date(d)
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
    },
    computed: {
      highlightedDates() {
        let dates = []
        let day4 = moment(this.dateFrom).subtract(1, 'day')
        let day7 = moment(this.dateFrom).subtract(1, 'day')
        for (let i = 0; i < 15; i++) {
          if (this.selectedShift === '25' || this.selectedShift === '52') {
            dates.push(day7.add(7, 'day').toDate())
          } else if (this.selectedShift === '22' || this.selectedShift === '13') {
            dates.push(day4.add(4, 'day').toDate())
          }
        }
        return {dates: dates}
      }
    }
  }
</script>
